import { useRef, useState } from "react";
import { RefreshCw } from "lucide-react";
import { waitForIdle } from "@/lib/api";

const TRIGGER = 70;
const isMobile = () => window.matchMedia("(max-width: 767px)").matches;
const inOverlay = (el) => !!el.closest?.("[role=dialog], [data-radix-popper-content-wrapper]");

export function PullToRefresh({ onRefresh, children }) {
  const start = useRef(null);
  const [pull, setPull] = useState(0);
  const [refreshing, setRefreshing] = useState(false);

  const onTouchStart = (e) => {
    if (refreshing || !isMobile() || window.scrollY > 0 || inOverlay(e.target)) return;
    start.current = { y: e.touches[0].clientY, x: e.touches[0].clientX };
  };
  const onTouchMove = (e) => {
    if (!start.current) return;
    const dy = e.touches[0].clientY - start.current.y;
    const dx = Math.abs(e.touches[0].clientX - start.current.x);
    if (dy <= 0 || dx > dy || window.scrollY > 0) { setPull(0); return; }
    setPull(Math.min(dy * 0.5, 110));
  };
  const onTouchEnd = async () => {
    if (!start.current) return;
    start.current = null;
    if (pull < TRIGGER) { setPull(0); return; }
    setRefreshing(true); setPull(TRIGGER);
    onRefresh();
    await waitForIdle();
    await new Promise((r) => setTimeout(r, 300));
    setRefreshing(false); setPull(0);
  };

  const shown = refreshing || pull > 4;
  return (
    <div onTouchStart={onTouchStart} onTouchMove={onTouchMove} onTouchEnd={onTouchEnd} onTouchCancel={onTouchEnd}>
      <div aria-hidden={!shown} data-testid="ptr-indicator" data-state={refreshing ? "refreshing" : pull >= TRIGGER ? "armed" : "idle"}
        className="md:hidden fixed left-1/2 z-40 -translate-x-1/2 pointer-events-none"
        style={{ top: `calc(3.5rem + env(safe-area-inset-top) + ${Math.max(pull - 40, -44)}px)`, opacity: shown ? 1 : 0,
                 transition: start.current ? "none" : "top 200ms ease, opacity 200ms ease" }}>
        <div className={`h-10 w-10 rounded-full grid place-items-center shadow-md border ${pull >= TRIGGER || refreshing ? "bg-primary text-primary-foreground border-primary" : "bg-card text-primary border-border"}`}>
          <RefreshCw className={`h-4 w-4 ${refreshing ? "animate-spin" : ""}`} style={refreshing ? undefined : { transform: `rotate(${pull * 3}deg)` }} />
        </div>
      </div>
      {children}
    </div>
  );
}
